import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { listContainer } from './style';
import { Col, Row, Container } from 'react-bootstrap';
import Contents from './Contents';

const listNovel = ({
    fungsinya, listNovelnya
  }) => {
  return (
      <div className={listContainer}>
        {listNovelnya.length !== 0
          && (
      <Contents fungsinya={fungsinya} listNovelnya={listNovelnya} />
          )}

        {listNovelnya.length === 0
                  && (
                    <div className="textKosong">Novel Tidak ditemukan</div>
                  )}
    </div>
  );
};
export default listNovel;
